import { Task, Timestamp, WeekDays } from '@griply/types';
import { getDueTaskPlanning, getTaskPlanning } from '@griply/utils';
import { endOfDay, isAfter, isBefore, isSameDay, startOfDay } from 'date-fns';
import { useMemo } from 'react';

export type UseTaskPlannedOccurrenceForDateOptions = {
  weekStartsOn: WeekDays;
  today: Timestamp;
};

export const useTaskPlannedOccurrenceForDate = (
  task: Task,
  date: Timestamp,
  { weekStartsOn, today }: UseTaskPlannedOccurrenceForDateOptions,
  enabled = true,
) =>
  useMemo(() => {
    if (!enabled) {
      return undefined;
    }

    const planning = getTaskPlanning(task, {
      startDate: startOfDay(date),
      endDate: endOfDay(date),
      today,
      weekStartsOn,
      uncompletedOnly: true,
    });
    const plannedOnDate = planning.find(({ date: _date }) =>
      isSameDay(_date, date),
    );

    if (plannedOnDate) {
      return plannedOnDate;
    }

    if (isSameDay(date, today) || isBefore(date, today)) {
      const duePlanning = getDueTaskPlanning(task, {
        date,
        today,
        weekStartsOn,
        uncompletedOnly: true,
      });

      return duePlanning[0];
    }

    return planning.find(({ date: _date }) => isAfter(_date, date));
  }, [date, task, today, weekStartsOn, enabled]);
